import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  HostListener,
} from "@angular/core";
import { ScrollingService } from "../services/scrolling.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  @ViewChild("top", { static: true }) topElement: ElementRef;
  @ViewChild("angebot", { static: true }) angebotElement: ElementRef;
  @ViewChild("jobs", { static: true }) jobsElement: ElementRef;
  @ViewChild("standort", { static: true }) standortElement: ElementRef;
  @ViewChild("kontakt", { static: true }) kontaktElement: ElementRef;

  private _cookieLoaded = false;
  private _showMaps = false;
  get showMaps(): boolean {
    if (!this._cookieLoaded) {
      this._cookieLoaded = true;
      this._showMaps = this.getCookie("lMaps") == "true";
    }
    return this._showMaps;
  }
  set showMaps(val: boolean) {
    this._showMaps = val;
    if (val) {
      this.setCookie("lMaps", "true", 7);
    } else {
      this.deleteCookie("lMaps");
    }
  }

  constructor(private scrolling: ScrollingService) {
    this.scrolling.reset();
  }

  ngOnInit() {}

  private isElementInViewport(el): boolean {
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while (el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }

    return (
      top < window.pageYOffset + window.innerHeight &&
      left < window.pageXOffset + window.innerWidth &&
      top + height - 100 > window.pageYOffset &&
      left + width > window.pageXOffset
    );
  }

  @HostListener("window:scroll", ["$event"])
  keyEvent(event: any) {
    if (this.isElementInViewport(this.topElement.nativeElement)) {
      this.scrolling.index = 0;
    } else if (this.isElementInViewport(this.angebotElement.nativeElement)) {
      this.scrolling.index = 1;
    } else if (this.isElementInViewport(this.jobsElement.nativeElement)) {
      this.scrolling.index = 2;
    } else if (
      this.isElementInViewport(this.standortElement.nativeElement) ||
      this.isElementInViewport(this.kontaktElement.nativeElement)
    ) {
      this.scrolling.index = 3;
    }
  }

  private getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
  private setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }
  private deleteCookie(cname) {
    document.cookie =
      cname + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  }
}
